<ng-container *ngIf="showAlways || unread > 0">

  <hk-wc-icon
    name="chat"
    size="28"
    class="rkt-unread-chats__icon"
    [class.text--primary]="unread > 0">
  </hk-wc-icon>

  <span
    *ngIf="unread > 0"
    class="rkt-unread-chats__number text--primary"
  >
    {{ unread }}
  </span>

</ng-container>
